import appRoutes from './routeConfig';
import {
    AssignmentIndOutlined,
    PeopleOutlined,
    NearbyErrorOutlined,
    HomeOutlined,
    BusinessOutlined,
    DescriptionOutlined,
    BadgeOutlined,
    FolderSharedOutlined,
    FolderOutlined,
    StorageOutlined,
    LiveHelpOutlined,
    AssessmentOutlined,
    FormatListBulletedOutlined,
    PasswordOutlined,
    SupportOutlined,
    EscalatorOutlined,
    DoNotDisturbOutlined,
    AssignmentLateOutlined,
    PendingActionsOutlined,
} from '@mui/icons-material';

const menuConfig = [
    {
        groupName: 'Home',
        menus: [
            {
                title: 'Dashboard',
                path: appRoutes.internal.root,
                icon: <HomeOutlined />,
                subMenus: [],
                id: 'getDashboardStatsForLoggedInInternalUser',
            },
        ],
    },
    {
        groupName: 'Cases',
        menus: [
            {
                title: 'Case Management',
                path: appRoutes.internal.caseMgt.root,
                icon: <FolderOutlined />,
                id: 'getAllCases',
                subMenus: [
                    {
                        title: 'All Cases',
                        path: appRoutes.internal.caseMgt.allCases,
                        icon: <DescriptionOutlined />,
                        id: 'getAllCases',
                    },
                    {
                        title: 'Escalated Cases',
                        path: appRoutes.internal.caseMgt.escalatedCases,
                        icon: <EscalatorOutlined />,
                        id: 'getUnassignedBreachedCases',
                    },
                    {
                        title: 'Closed Cases',
                        path: appRoutes.internal.caseMgt.closedCases,
                        icon: <DoNotDisturbOutlined />,
                        id: 'getAllClosedCases',
                    },
                    {
                        title: 'Team Lead Assigned Cases',
                        path: appRoutes.internal.caseMgt.teamLeadAssignedCases,
                        icon: <AssignmentIndOutlined />,
                        id: 'getTeamLeadAssignedCases',
                    },
                    {
                        title: 'Unassigned Breached Cases',
                        path: appRoutes.internal.caseMgt
                            .unassignedBreachedCases,
                        icon: <AssignmentLateOutlined />,
                        id: 'getUnassignedBreachedCases',
                    },
                    {
                        title: 'B2B Breached Cases',
                        path: appRoutes.internal.caseMgt.bank2BankBreachedCases,
                        icon: <AssignmentLateOutlined />,
                        // id: 'getAllBank2BankBreachedCases',
                        id: 'getUnassignedBreachedCases',
                    },
                    {
                        title: 'Root Cause Analysis',
                        path: appRoutes.internal.caseMgt.rootCauseAnalysis,
                        icon: <NearbyErrorOutlined />,
                        id: 'GetRootCauseAnalysisUploadForInstitution',
                    },
                    // {
                    //     title: 'Reported Institutions',
                    //     path: appRoutes.internal.caseMgt.reportedInstitutions,
                    //     icon: <BusinessOutlined />,
                    //     id: 'getAllReportedFIsCases',
                    // },
                ],
            },
            {
                title: 'Owned Cases',
                path: appRoutes.internal.ownedCases.root,
                icon: <FolderSharedOutlined />,
                id: 'getLoggedInUserAssignedCases',
                subMenus: [
                    {
                        title: 'My Cases',
                        path: appRoutes.internal.ownedCases.all,
                        icon: <AssignmentIndOutlined />,
                        id: 'getLoggedInUserAssignedCases',
                    },
                    // {
                    //     title: 'Cases Work Flow History',
                    //     path: appRoutes.internal.ownedCases.workFlowHistory,
                    //     icon: <DescriptionOutlined />,
                    //     id: '',
                    // },
                    {
                        title: 'Pending Bank Cases',
                        path: appRoutes.internal.ownedCases.pendingBankCases,
                        icon: <PendingActionsOutlined />,
                        id: 'getMyPendingBankCases',
                    },
                ],
            },
            {
                title: 'Upload Processing Status',
                path: appRoutes.internal.returnProcessing,
                icon: <StorageOutlined />,
                id: 'GetCasesUploadSummaryForCPD',
                subMenus: [],
            },
            {
                title: 'Reports',
                path: appRoutes.internal.reports,
                icon: <AssessmentOutlined />,
                id: '',
                subMenus: [],
            },
            {
                title: 'FAQs',
                path: appRoutes.internal.faqs,
                icon: <LiveHelpOutlined />,
                id: 'GetAllFAQs',
                subMenus: [],
            },
        ],
    },
    {
        groupName: 'User Management',
        menus: [
            {
                title: 'Users',
                path: appRoutes.internal.users.root,
                icon: <PeopleOutlined />,
                id: 'getAllUsers',
                subMenus: [
                    {
                        title: 'Internal Users',
                        path: appRoutes.internal.users.all,
                        icon: <PeopleOutlined />,
                        id: 'getAllUsers',
                        subMenus: [],
                    },
                    {
                        title: 'External Users',
                        path: appRoutes.internal.users.external,
                        icon: <PeopleOutlined />,
                        id: 'getAllUsers',
                        subMenus: [],
                    },
                ],
            },
            {
                title: 'Roles',
                path: appRoutes.internal.users.userRoles,
                icon: <BadgeOutlined />,
                id: 'getAllRoles',
                subMenus: [],
            },
            {
                title: 'Audit Trail',
                path: appRoutes.internal.users.audits,
                icon: <PasswordOutlined />,
                id: 'GetAllAuditTrail',
                subMenus: [],
            },
            {
                title: 'Institutions',
                path: appRoutes.internal.institutions.root,
                icon: <BusinessOutlined />,
                id: 'getAllInstitutions',
                subMenus: [
                    {
                        title: 'All Institutions',
                        path: appRoutes.internal.institutions.all,
                        icon: <BusinessOutlined />,
                        id: 'getAllInstitutions',
                        subMenus: [],
                    },
                    {
                        title: 'Institutions Types',
                        path: appRoutes.internal.institutions.institutionTypes,
                        icon: <BusinessOutlined />,
                        id: 'getInstitutionTypes',
                        subMenus: [],
                    },
                    // {
                    //     title: 'Institution Admins',
                    //     path: appRoutes.internal.institutions.institutionAdmins,
                    //     icon: <PeopleOutlined />,
                    //     id: '',
                    //     subMenus: []
                    // },
                    {
                        title: 'Regulatory Directives',
                        path: appRoutes.internal.institutions
                            .regulatoryDirectives,
                        icon: <PeopleOutlined />,
                        id: 'getAllRegulatoryDirectives',
                        subMenus: [],
                    },
                    {
                        title: 'Sanctions',
                        path: appRoutes.internal.institutions.sanctions,
                        icon: <PeopleOutlined />,
                        id: 'getAllSanctions',
                        subMenus: [],
                    },
                    {
                        title: 'Warnings',
                        path: appRoutes.internal.institutions.warnings,
                        icon: <PeopleOutlined />,
                        id: 'getAllWarnings',
                        subMenus: [],
                    },
                    {
                        title: 'Technical Sessions',
                        path: appRoutes.internal.institutions.technicalSessions,
                        icon: <PeopleOutlined />,
                        id: 'getAllTechnicalSessions',
                        subMenus: [],
                    },
                ],
            },
            {
                title: 'Teams',
                path: appRoutes.internal.users.teams,
                icon: <PeopleOutlined />,
                id: 'getAllTeams',
                subMenus: [],
            },
            {
                title: 'Complaint Category',
                path: appRoutes.internal.category.root,
                icon: <FormatListBulletedOutlined />,
                id: 'getAllCategories',
                subMenus: [
                    {
                        title: 'All Categories',
                        path: appRoutes.internal.category.all,
                        icon: <FormatListBulletedOutlined />,
                        id: 'getAllCategories',
                        subMenus: [],
                    },
                    {
                        title: 'Sub Categories',
                        path: appRoutes.internal.category.subCategories,
                        icon: <FormatListBulletedOutlined />,
                        id: 'getAllSubcategories',
                        subMenus: [],
                    },
                ],
            },
        ],
    },
    {
        groupName: 'Support',
        menus: [
            {
                title: 'Help',
                path: appRoutes.internal.help,
                icon: <SupportOutlined />,
                id: '',
                subMenus: [],
            },
        ],
    },
];

export default menuConfig;
